export default __webpack_public_path__ + "static/media/standard-card-image.e1926f31.png";